/* LFDM — pop-up d'ajout rapide générique (Hygiène, Linge, Jouets…).
   Les données viennent de <script type="application/json" data-lfdm-uni>
   rendu par la section « LFDM — Uni. grille » : options réelles du produit
   (noms et valeurs), variantes, prix. Aucun libellé ni prix n'est écrit ici.
   Pas d'abonnement sur ces familles : un seul mode d'achat.

   Sélection en cascade, comme la fiche produit : les valeurs d'un axe sont
   filtrées par les choix des axes précédents, et une valeur qui ne mène à
   aucune variante disponible n'est pas affichée du tout. */
(function () {
  var src = document.querySelector('script[data-lfdm-uni]');
  var modal = document.getElementById('lfdmUq');
  if (!src) return;

  var DATA;
  try { DATA = JSON.parse(src.textContent); } catch (e) { return; }
  var CFG = DATA.cfg || {};
  var PRODUCTS = DATA.products || [];

  var $ = function (id) { return document.getElementById(id); };
  var eur = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var byHandle = function (h) {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].h === h) return PRODUCTS[i];
    return null;
  };

  /* ---------- ajout direct (produits sans variante) ---------- */
  function cartAdd(item, msg) {
    if (window.LFDM && LFDM.cartAdd) return LFDM.cartAdd(item, msg);
    return Promise.resolve();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-uni-add]') : null;
    if (!t) return;
    e.preventDefault();
    var id = t.getAttribute('data-uni-add');
    if (!id || t.hasAttribute('data-busy')) return;
    t.setAttribute('data-busy', '');
    cartAdd({ id: String(id), quantity: 1 }, CFG.toast || 'Ajouté au panier')
      .then(function () { t.removeAttribute('data-busy'); }, function () { t.removeAttribute('data-busy'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest ? e.target.closest('[data-uni-add],[data-uni-qa]') : null;
    if (t) { e.preventDefault(); t.click(); }
  });

  if (!modal) return;

  /* ---------- état ---------- */
  var S = { p: null, sel: [], qty: 1 };

  var elBody = $('uqBody'), elQtyBlock = $('uqQtyBlock'), elQtyLab = $('uqQtyLab'), elQty = $('uqQty');
  var elName = $('uqName'), elGamme = $('uqGamme'), elSub = $('uqSub'), elImg = $('uqImg'), elIcon = $('uqIcon');
  var elSumLab = $('uqSumLab'), elTotal = $('uqTotal'), elUnit = $('uqUnit'), elSave = $('uqSave');
  var elAdd = $('uqAdd'), elMore = $('uqMore'), elMoreLink = $('uqMoreLink');

  /* ---------- résolution des variantes ---------- */
  function nOpts(p) { return p.def ? 0 : (p.onames || []).length; }

  /* variantes compatibles avec une sélection partielle (null = indifférent).
     La longueur de `sel` borne les axes contraints. */
  function match(p, sel) {
    var out = [];
    for (var i = 0; i < p.vars.length; i++) {
      var v = p.vars[i], ok = true;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] != null && v.o[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) out.push(v);
    }
    return out;
  }

  function variant(p) {
    var c = match(p, S.sel);
    return c.length ? c[0] : null;
  }

  /* choix des axes strictement avant i */
  function prefix(i) {
    var s = [];
    for (var j = 0; j < i; j++) s.push(S.sel[j]);
    return s;
  }
  function probe(i, val) {
    var s = prefix(i);
    s[i] = val;
    return match(S.p, s);
  }

  /* valeurs réellement possibles pour l'axe i, dans l'ordre déclaré dans Shopify.
     Seules les valeurs menant à au moins une variante DISPONIBLE sont proposées :
     on n'affiche jamais une combinaison indisponible. Si aucune valeur de l'axe
     n'est disponible (produit entièrement épuisé), on retombe sur la liste
     complète, désactivée, pour que la pop-up reste lisible. */
  function valuesFor(p, i) {
    var pool = match(p, prefix(i));
    var seen = [];
    for (var k = 0; k < pool.length; k++) {
      var v = pool[k].o[i];
      if (v != null && seen.indexOf(v) < 0) seen.push(v);
    }
    var declared = p.ovals[i] || [];
    var out = [];
    for (var d = 0; d < declared.length; d++) if (seen.indexOf(declared[d]) >= 0) out.push(declared[d]);
    for (var s2 = 0; s2 < seen.length; s2++) if (out.indexOf(seen[s2]) < 0) out.push(seen[s2]);

    var av = [];
    for (var a = 0; a < out.length; a++) if (anyAvail(probe(i, out[a]))) av.push(out[a]);
    return av.length ? av : out;
  }

  function minPrice(list) {
    var m = 0;
    for (var i = 0; i < list.length; i++) if (!m || list[i].pr < m) m = list[i].pr;
    return m;
  }
  function anyAvail(list) {
    for (var i = 0; i < list.length; i++) if (list[i].av) return true;
    return false;
  }

  /* après un choix sur l'axe i, on recale les axes suivants sur une
     combinaison qui existe (et disponible si possible) */
  function reconcile(p, changed) {
    var n = nOpts(p);
    for (var j = changed + 1; j < n; j++) {
      var vals = valuesFor(p, j);
      if (!vals.length) { S.sel[j] = null; continue; }
      if (vals.indexOf(S.sel[j]) >= 0) continue;
      var pick = null;
      for (var k = 0; k < vals.length; k++) {
        if (anyAvail(probe(j, vals[k]))) { pick = vals[k]; break; }
      }
      S.sel[j] = pick || vals[0];
    }
  }

  /* ---------- rendu ---------- */
  function optRow(checked, title, sub, price, disabled) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'qa-opt';
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', checked ? 'true' : 'false');
    if (disabled) b.disabled = true;
    b.innerHTML = '<span class="rad"></span><span class="txt"><b></b><small></small></span><span class="pr"></span>';
    b.querySelector('b').textContent = title;
    b.querySelector('small').textContent = sub || '';
    b.querySelector('.pr').textContent = price || '';
    return b;
  }

  function chip(checked, title, disabled) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'qa-sz';
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', checked ? 'true' : 'false');
    if (disabled) b.disabled = true;
    b.innerHTML = '<b></b>';
    b.querySelector('b').textContent = title;
    return b;
  }

  function renderOpts() {
    var p = S.p, n = nOpts(p);
    /* on retire les blocs d'options précédents, jamais le bloc quantité */
    var olds = elBody.querySelectorAll('[data-uq-opt]');
    for (var o = 0; o < olds.length; o++) elBody.removeChild(olds[o]);

    for (var i = 0; i < n; i++) {
      (function (i) {
        var vals = valuesFor(p, i);
        if (!vals.length) return;

        var block = document.createElement('div');
        block.className = 'qa-block';
        block.setAttribute('data-uq-opt', String(i));

        var lab = document.createElement('div');
        lab.className = 'qa-lab';
        var labId = 'uqLab' + i;
        lab.innerHTML = '<span id="' + labId + '"></span><em></em>';
        lab.querySelector('span').textContent = p.onames[i];
        block.appendChild(lab);

        var asChips = vals.length > 4;
        var box = document.createElement('div');
        box.className = asChips ? 'qa-sizes' : 'qa-opts';
        box.setAttribute('role', 'radiogroup');
        box.setAttribute('aria-labelledby', labId);

        vals.forEach(function (val) {
          var c = probe(i, val);
          var out = !anyAvail(c);
          var checked = S.sel[i] === val;
          var el;
          if (asChips) {
            el = chip(checked, val, out);
          } else {
            el = optRow(checked, val, out ? (CFG.soldOutLabel || 'Épuisé') : '', eur(minPrice(c)), out);
          }
          if (!out) {
            el.addEventListener('click', function () {
              S.sel[i] = val;
              reconcile(p, i);
              render();
            });
          }
          box.appendChild(el);
        });

        block.appendChild(box);
        elBody.insertBefore(block, elQtyBlock);
      })(i);
    }
  }

  function renderFoot() {
    var p = S.p;
    var v = variant(p);
    elQtyLab.textContent = CFG.qtyLabel || 'Quantité';
    elQty.textContent = S.qty;

    var ready = !!(v && v.av);
    elSumLab.textContent = p.def ? p.t : (v ? v.t : '');

    var total = ready ? v.pr * S.qty : 0;
    elTotal.textContent = total ? eur(total) : '—';
    elUnit.textContent = (ready && S.qty > 1) ? eur(v.pr) + ' l’unité' : '';

    var save = '';
    if (ready && v.cp && v.cp > v.pr) save = '− ' + eur((v.cp - v.pr) * S.qty);
    elSave.textContent = save;

    if (!v) {
      elAdd.textContent = CFG.chooseLabel || 'Choisissez une option';
      elAdd.disabled = true;
    } else if (!v.av) {
      elAdd.textContent = CFG.soldOutLabel || 'Épuisé';
      elAdd.disabled = true;
    } else {
      elAdd.textContent = (CFG.addLabel || 'Ajouter au panier') + ' — ' + eur(total);
      elAdd.disabled = false;
    }
  }

  function render() {
    var p = S.p;
    if (!p) return;
    elName.textContent = p.t;
    elGamme.textContent = p.g || '';
    elGamme.parentNode.hidden = !p.g;
    elSub.textContent = p.a || '';

    var v = variant(p);
    var img = (v && v.img) || p.img;
    if (img) { elImg.src = img; elImg.hidden = false; elIcon.style.display = 'none'; }
    else { elImg.hidden = true; elIcon.style.display = ''; }

    renderOpts();
    renderFoot();

    elMore.hidden = false;
    elMoreLink.textContent = CFG.moreLabel || 'Voir toute la fiche produit';
    elMoreLink.href = p.u;
  }

  function setProduct(p, wantId) {
    S.p = p;
    S.qty = 1;
    S.sel = [];
    var n = nOpts(p);
    for (var i = 0; i < n; i++) S.sel.push(null);
    /* pré-sélection : la variante demandée (produit scanné) si elle est
       disponible, sinon la première variante disponible, sinon la première */
    var pick = null;
    if (wantId) {
      for (var w = 0; w < p.vars.length; w++) {
        if (String(p.vars[w].id) === String(wantId) && p.vars[w].av) { pick = p.vars[w]; break; }
      }
    }
    if (!pick) { for (var k = 0; k < p.vars.length; k++) { if (p.vars[k].av) { pick = p.vars[k]; break; } } }
    if (!pick) pick = p.vars[0];
    if (pick) for (var j = 0; j < n; j++) S.sel[j] = pick.o[j];
  }

  /* ---------- ouverture / fermeture ---------- */
  function open(p, wantId) {
    if (!p) return;
    setProduct(p, wantId);
    render();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var f = modal.querySelector('.qa-opt:not([disabled]), .qa-sz:not([disabled])');
    if (f) f.focus();
  }
  function close() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest ? e.target.closest('[data-uni-qa]') : null;
    if (q) {
      e.preventDefault();
      open(byHandle(q.getAttribute('data-uni-qa')), q.getAttribute('data-uni-variant'));
      return;
    }
    if (e.target.closest && e.target.closest('[data-close-uq]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  elQtyBlock.addEventListener('click', function (e) {
    var b = e.target.closest('[data-uq-qty]');
    if (!b) return;
    S.qty = b.getAttribute('data-uq-qty') === '+' ? Math.min(S.qty + 1, 99) : Math.max(1, S.qty - 1);
    renderFoot();
  });

  /* ---------- ajout au panier ---------- */
  elAdd.addEventListener('click', function () {
    var v = variant(S.p);
    if (!v || !v.av) return;
    elAdd.disabled = true;
    cartAdd({ id: String(v.id), quantity: S.qty }, CFG.toast || 'Ajouté au panier')
      .then(function () { elAdd.disabled = false; close(); }, function () { elAdd.disabled = false; });
  });

  /* ---------- second visuel au tap (tactile) ---------- */
  if (window.matchMedia && !window.matchMedia('(hover:hover)').matches) {
    document.querySelectorAll('.lfdm-uni .prod-media').forEach(function (m) {
      m.addEventListener('click', function (e) {
        if (!m.classList.contains('show-2')) { e.preventDefault(); m.classList.add('show-2'); }
      });
    });
  }
})();